export default __webpack_public_path__ + "static/opus-logo-full-89b6718d86fc261e658f867ea1d8a5fe.webp";